/**
 * @generated SignedSource<<68e3b51d3693ea8fa295ee848c34359a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbDesignYourOwn_item$data = {
  readonly isDyoCustomizable: boolean | null;
  readonly " $fragmentType": "PdpSharedBlurbDesignYourOwn_item";
};
export type PdpSharedBlurbDesignYourOwn_item$key = {
  readonly " $data"?: PdpSharedBlurbDesignYourOwn_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBlurbDesignYourOwn_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbDesignYourOwn_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDyoCustomizable",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3f9d033f1852bd4f72fc01ecdd86894b";

export default node;
